import { Component } from '@angular/core';

@Component({
  selector: 'app-evaluation-pv',
  templateUrl: './evaluation-pv.component.html',
  styleUrls: ['./evaluation-pv.component.css']
})
export class EvaluationPvComponent {
  imageLogo: string = 'assets/logo.png';
  numeroPv: string = 'PV123456';
  nom: string = 'Projet Wegestu';
  type: string = 'Audit';
  dateEnvoi: string = '2024-02-01';
  dateReception: string = '2024-02-02';
  dateCompteRendu: string = '2024-02-05';

  comment: string = 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt, sed minus! Provident maxime quia cumSapiente labore cum nam facere reprehenderit nulla repudiandae, ipsam placeat, adipisci beatae doloresvel corrupti';
  signatureImage: string = 'assets/signature.png';
  nameEsn: string = 'ESN Consulting';
  dateEsn: string = '2024-02-03';
  nameConsultant: string = 'John Doe';
  dateConsultant: string = '2024-02-04';
  starImage: string = 'assets/media/icons/start.svg';
  starInactiveImage: string = 'assets/star-inactive.png';
  evaluation = [
    {
      subjectTitle: 'Qualité du service',
      subject: [
        { question: 'La rapidité du service était-elle satisfaisante ?', stars: 4, comment: 'Très bon service.' },
        { question: 'L’amabilité du personnel était-elle appréciable ?', stars: 5, comment: 'Personnel très courtois.' }
      ]
    },
    {
      subjectTitle: 'Délais de livraison',
      subject: [
        { question: 'Les délais ont-ils été respectés ?', stars: 3, comment: 'Légèrement en retard.' }
      ]
    }
  ];
  
  hasValidSubjects(evaluationItem: any): boolean {
    return evaluationItem?.subjectTitle && evaluationItem?.subject && evaluationItem.subject.length > 0;
}

}
